/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Router } from "@angular/router";
import { ActionInstance } from "../../models/action-instance";
import { Rule } from "../../models/rule";
import { Type } from "../../models/rule-condition";
import { Step } from "./rule-editor.component";
import { Component, Input, EventEmitter, Output } from "@angular/core";

declare var $: any;

@Component({
  selector: 'app-rule-editor-lhs-nav',
  templateUrl: './rule-editor-lhs-navigation.component.html'
})
export class RuleEditorLhsNavigationComponent {
  
  //Rule Steps shown in the UI, referenced so that it can be used by the .html
  mSteps = Step;
  
  @Input()    //Rule currently being edited
  mRule: Rule;
  
  @Input()    //Step the Rule being edited is on, needed so that the highlight can be shown
  mStep: Step;
  
  @Output()   //Event emitted when the User clicks on a Step, emitted so the Editor can switch Steps by the User clicking on them here
  stepSelected = new EventEmitter<Step>();
  
  mSourceTypes = Type;

    constructor(
      private mRouter: Router
    ) {}

  selectPreviousStepClicked(): void {
    switch (this.mStep) {
      case Step.S2_SET_UP_PARAMETERS: {
        this.stepSelected.emit(Step.S1_SELECT_TRIGGER);
        break;
      }
      case Step.S3_ADD_FILTERS: {
        this.stepSelected.emit(Step.S2_SET_UP_PARAMETERS);
        break;
      }
      case Step.S4_CHOOSE_REACTIONS: {
        this.stepSelected.emit(Step.S3_ADD_FILTERS);
        break;
      }
      case Step.S5_REVIEW_AND_FINISH: {
        this.stepSelected.emit(Step.S4_CHOOSE_REACTIONS);
        break;
      }
    }
  }

  selectNextStepClicked(): void {
    switch (this.mStep) {
      case Step.S1_SELECT_TRIGGER: {
        this.stepSelected.emit(Step.S2_SET_UP_PARAMETERS);
        break;
      }
      case Step.S2_SET_UP_PARAMETERS: {
        this.stepSelected.emit(Step.S3_ADD_FILTERS);
        break;
      }
      case Step.S3_ADD_FILTERS: {
        this.stepSelected.emit(Step.S4_CHOOSE_REACTIONS);
        break;
      }
      case Step.S4_CHOOSE_REACTIONS: {
        this.stepSelected.emit(Step.S5_REVIEW_AND_FINISH);
        break;
      }
    }
  }

  getIconForActionInstance(actionInstance: ActionInstance): string {
    if (actionInstance != null && actionInstance.action != null && actionInstance.action.glyph != null && actionInstance.action.glyph.length > 0) {
      return actionInstance.action.glyph;
    } else {
      return 'fa-question';
    }
  }

  getLabelForEventParameter(source: string): string {
	if (this.mRule.event != null) {}
	  const eventProperty = this.mRule.event.properties.find(p => p.property == source);
	  return eventProperty.name;
  }
  
    /**
   * Called when the User clicks the Cancel button to exit the Rule Editor
   */
  onCancelClicked(): void {
    console.log("RuleEditorComponent: onCancelClicked() called");
    //Navigate back to the Rules List
    this.mRouter.navigateByUrl('/rules');
  }

}
